import * as React from 'react';

import { ClientPortal } from './ClientPortal';
import { ClientComponent } from '../ClientComponent';

export const Portal: React.FC<React.PropsWithChildren> = props => {
  return (
    <ClientComponent>
      <ClientPortal {...props} />
    </ClientComponent>
  );
};
